import {Attribute} from "./api/attribute";
import {coerceToBoolean} from "./coercer";


export function getDefaultValue(attr: Attribute) {

  if (attr.defaultValue === undefined) {
    return undefined;
  }

  if (attr.defaultValue === null) {
    return null;
  }

  if (attr.dataType === 'Boolean') {
    return coerceToBoolean(attr.defaultValue);
  }else if(attr.dataType === 'Integer') {
    return parseInt(attr.defaultValue)
  }
  else {
    return attr.defaultValue;
  }
}

